import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useUpdateEventModerationStatusMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const updateModerationStatus = api.updateEventModerationStatus;

  return useMutation({
    mutationFn: async ({ eventId, payload }) => {
      if (!updateModerationStatus) {
        throw new Error('Moderation decisions are not available for this account');
      }
      const result = await updateModerationStatus(eventId, payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to update moderation status');
      }
      return result.data;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (variables?.eventId) {
        await queryClient.invalidateQueries({ queryKey: queryKeys.detail(variables.eventId) });
      }
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    ...options,
  });
};
